import { Component, Input, OnInit } from '@angular/core';
import {CommonInfoService} from '../../cart-process/common-info.service';
import {PriceFormatPipe} from '../../utils/pipes/price-format.pipe';
import Utils from '../../utils/utils';

@Component({
  selector: 'new-offer-slot-discount-info',
  templateUrl: './new-offer-slot-discount-info.component.html',
})
export class NewOfferSlotDiscountInfoComponent implements OnInit {

  @Input() slotsNumber: number;

  public discountInfo: string = '';
  private priceFormat: PriceFormatPipe = new PriceFormatPipe();

  constructor(
    public commonInfo: CommonInfoService
  ) {
  }

  ngOnInit(): void {
    if (this.commonInfo.simCardDiscount) {
      const simCardDiscount = this.commonInfo.simCardDiscount[this.commonInfo.taxName];
      const priceEnding = this.commonInfo.priceEnding;
      const formattedPrice = this.priceFormat.transform(simCardDiscount);
      const price = `${formattedPrice} ${priceEnding}`;
      const requiredParticipants = this.commonInfo.simCardDiscount?.requiredParticipants;

      if ((this.slotsNumber > requiredParticipants - 1 && !this.commonInfo.isNextSim) ||
         (this.slotsNumber + this.commonInfo.currentlyProcessed) > requiredParticipants - 1 && this.commonInfo.isNextSim) {
        this.discountInfo = `Otrzymujesz ${this.commonInfo.isNextSim ? `<br class="show-for-small-only">` : ''}<b>rabat ${price} miesięcznie</b> ${!this.commonInfo.isNextSim ? ' za' : ''}&nbsp;`;

        if (this.commonInfo.isNextSim) {
          return;
        } else if (this.commonInfo.isRetentionOffer) {
          this.discountInfo += `przedłużenie minimum ${requiredParticipants} numerów`;
        } else {
          this.discountInfo += `zakup minimum ${requiredParticipants} numerów`;
        }
      } else {
        this.discountInfo = `Dodaj ${!this.commonInfo.isNextSim ? `${Utils.numberDeclensionFormat(requiredParticipants).toLowerCase()}` : 'numer'} i otrzymaj <b>rabat ${price} miesięcznie</b>`;
      }
    }
  }
}
